import React, { useEffect } from "react";
import { Row, Col, Container } from "react-bootstrap";
import "./DefinationndInterpretation.css";
import { trackEvent, trackPageView } from "../../utils/tracking";
function DefinationndInterpretation() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/SIDdisclosures/Definitions-interpretation",
      "jmf_sid-disclosures_definations-interpretations",
    );
    //   trackPageView(
    //     "http://localhost:710/SIDdisclosures/Definitions-interpretation",
    //     "jmf_sid-disclosures_definations-interpretations"
    //   );

    trackEvent({
      category: "Static Page",
      action: "SIDdisclosures DefinationAndInterpretation Page Loaded",
      label: "jmf_sid-disclosures_definations-interpretations",
      value: 1,
    });
  }, []);

  return (
    <section
      className="defin-unit product_fund-summary-sc"
      aria-label="Definitions or Interpretation information"
      role="region"
      tabIndex="0"
    >
      <Container>
        <Row>
          <Col>
            <div className="privacy-policy">
              <h2 className="definitionsHeader">1. Aadhaar</h2>
              <p>
                Aadhaar means the Aadhaar number issued by the Unique
                Identification Authority of India (UIDAI) under the Aadhaar
                (Targeted Delivery of Financial and Other Subsidies, Benefits
                and Services) Act, 2016, as amended from time to time.
              </p>
              <br />
              <h2 className="definitionsHeader">2. AMFI</h2>
              <p>
                Association of Mutual Funds in India, the industry association
                of mutual funds in India, incorporated on August 22, 1995 as a
                non-profit organisation.
              </p>
              <br />
              <h2 className="definitionsHeader">3. Applicable NAV</h2>
              <p>
                The Net Asset Value applicable for purchase,
                redemption/repurchase or switch-in/switch-out of Units, based on
                the time of the Business Day on which a valid application is
                accepted at an Official Point of Acceptance, subject to
                applicable cut-off timings, realization/availability of funds
                and other requirements specified under the SID, SAI, SEBI
                Regulations and Master Circular, as amended from time to time.
              </p>
              <br />

              <h2 className="definitionsHeader">
                4. AMC, JM Financial Asset Management Limited (“JMF AMC”), or
                Investment Manager
              </h2>
              <p>
                JM Financial Asset Management Limited, the Investment
                Manager/Asset Management Company of JM Financial Mutual Fund,
                incorporated under the Companies Act, 1956 and deemed to exist
                under the Companies Act, 2013, and including its successors and
                assigns.
              </p>
              <br />

              <h2 className="definitionsHeader">5. Associate</h2>
              <p>
                Associate means associate as defined under SEBI (Mutual Funds)
                Regulations, 2026 Business Day/Working Days Business Day /
                Working Day means any day other than: (a) Saturday or Sunday;
                (b) a day on which banks or the Reserve Bank of India in Mumbai
                are closed for business or clearing; (c) a day on which BSE
                Limited and/or the National Stock Exchange of India Limited is
                closed; (d) a day declared as a public or bank holiday at the
                relevant Official Point of Acceptance; (e) a day on which sale,
                redemption/repurchase or switching of Units is suspended; (f) a
                day on which normal business cannot be transacted due to natural
                calamity, bandh, strike, major system failure, market disruption
                or any other event as determined by the AMC/Trustee; (g) a day
                on which money markets are closed or not accessible for
                business; or (h) a day on which funds accompanying purchase
                applications cannot be realized or made available for
                investment, or investments cannot be liquidated and/or funds are
                not available for redemption/repurchase. The AMC/Trustee may
                declare any day as a Business Day or Non-Business Day for all or
                any Official Point(s) of Acceptance by notification.
                Applications received on Non-Business Days will be processed on
                the next Business Day at the Applicable NAV, subject to the SEBI
                Regulations and the Master Circular.
              </p>
              <br />
              <h2 className="definitionsHeader">6. Broker </h2>
              <p>
                means a stock broker as defined in the Securities and Exchange
                Board of India (Stock Brokers) Regulations, 2026.
              </p>
              <br />

              <h2 className="definitionsHeader">7. Calendar Year</h2>
              <p>
                Calendar Year means the period of 12 English calendar months
                commencing on January 1 and ending on December 31.
              </p>
              <br />
              <h2 className="definitionsHeader">8. Call Option</h2>

              <p>
                Call option is a financial contract between two parties, the
                buyer and the seller of the option. The call allows the buyer
                the right (but not the obligation) to buy a financial instrument
                (the underlying instrument) from the seller of the option at a
                certain time for a certain price (the strike price). The seller
                assumes the corresponding obligations. Note that the seller of
                the option undertakes to sell the underlying in exchange.
              </p>
              <br />

              <h2 className="definitionsHeader">9. Credit Rating Agency</h2>
              <p>
                means a body corporate registered with SEBI to carry on the
                business of rating of securities under the Securities and
                Exchange Board of India (Credit Rating Agencies) Regulations,
                1999, as amended from time to time.
              </p>
              <br />
              <h2 className="definitionsHeader">
                10. Corporate debt Securities
              </h2>
              <p>
                Corporate debt securities shall mean non-convertible debt
                securities, including debentures, bonds and such other
                securities of a company or a body corporate constituted by or
                under a Central or State Act, whether constituting a charge on
                the assets of the company or body corporate or not, but does not
                include debt securities issued by Government.
              </p>
              <br />
              <h2 className="definitionsHeader">11. Credit Risk</h2>
              <p>
                Risk of default in payment of principal or interest or both.
              </p>
              <br />

              <h2 className="definitionsHeader">12. Custodian</h2>
              <p>
                A person/body corporate who has been granted a certificate of
                registration to carry on the business of custodian of securities
                under the Securities and Exchange Board of India (Custodian)
                Regulations, 1996, as amended from time to time, and/or any
                other appropriate statutory or regulatory authority for custody
                of permitted overseas securities/assets. The custodian(s)
                appointed for the Scheme(s) shall be as disclosed in the SAI/SID
                and as updated from time to time.
              </p>
              <br />
              <h2 className="definitionsHeader">13. CDMDF</h2>
              <p>
                Corporate Debt Market Development Fund shall have the meaning
                assigned to it under clause (ga) of sub-regulation (1) of
                regulation 2 of the Securities and Exchange Board of India
                (Alternative Investment Funds) Regulations, 2012, as amended
                from time to time.
              </p>
              <br />

              <h2 className="definitionsHeader">14. Day</h2>
              <p>
                Any day (including Saturday, Sunday and holiday) as per English
                Calendar viz. 365 days in a year/ 366 days in a leap year.
              </p>
              <br />
              <h2 className="definitionsHeader">15. Depository</h2>

              <p>
                A body corporate as defined in the Depositories Act, 1996 (22 of
                1996).
              </p>
              <br />
              <h2 className="definitionsHeader">16. Derivative includes</h2>
              <p>
                Derivative includes: (i) a security derived from a debt
                instrument, share, loan, whether secured or unsecured, risk
                instrument, contract for differences or any other form of
                security; and (ii) a contract which derives its value from the
                prices, or index of prices, of underlying securities, and shall
                be construed in accordance with the Securities Contracts
                (Regulation) Act, 1956 and applicable SEBI/RBI requirements, as
                amended from time to time.
              </p>
              <br />
              <br />
              <h2 className="definitionsHeader">
                17. Equity related instruments/equity related securities
              </h2>
              <p>
                It would include convertible debentures, convertible preference
                shares, warrants carrying the right to obtain equity shares,
                equity derivatives, units of Real Estate Investment Trust
                (“REITs”) and such other instruments as may be specified by SEBI
                from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">
                18. ETF /Exchange Traded Fund
              </h2>
              <p>
                means a mutual fund scheme that invests in securities in the
                same proportion as an index of securities and in the manner
                specified by the Board and whose units are mandatorily listed
                and traded on a stock exchange platform.
              </p>

              <br />
              <h2 className="definitionsHeader">19. Exit Load</h2>
              <p>
                means the charge or fee levied by the mutual fund at the time of
                redemption or repurchase of units.
              </p>

              <br />
              <h2 className="definitionsHeader">20. Fixed Income Securities</h2>
              <p>
                Debt Securities created and issued by, inter alia, Central
                Government, State Government, Local Authorities, Municipal
                Corporations, PSUs, Public Companies, Private Companies, Bodies
                Corporate, Unincorporated SPVs and any other entities which may
                be recognized / permitted which yield a fixed or variable rate
                by way of interest, premium, discount or a combination of any of
                them.
              </p>

              <br />
              <h2 className="definitionsHeader">21. FPI</h2>
              <p>
                Foreign Portfolio Investor means a person registered with SEBI
                as a foreign portfolio investor under the Securities and
                Exchange Board of India (Foreign Portfolio Investors)
                Regulations, 2019, as amended from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">22. Financial Year</h2>
              <p>
                Financial Year means the period of 12 English calendar months
                commencing on April 1 and ending on March 31.
              </p>

              <br />
              <h2 className="definitionsHeader">23. Fraud</h2>
              <p>
                Fraud means a fraud as defined in clause (c) of sub-regulation
                (1) of regulation 2 of the Securities and Exchange Board of
                India (Prohibition of Fraudulent and Unfair Trade Practices
                Relating to Securities Market) Regulations, 2003
              </p>

              <br />
              <h2 className="definitionsHeader">24. Government Securities</h2>
              <p>
                Government Securities means securities created and issued by the
                Central Government or a State Government for the purpose of
                raising a public loan and having one of the forms specified in
                the Government Securities Act, 2006, as amended from time to
                time.
              </p>

              <br />
              <h2 className="definitionsHeader">25. Gold related instrument</h2>
              <p>
                Shall mean such instrument having gold as underlying, as may be
                specified by SEBI.
              </p>

              <br />
              <h2 className="definitionsHeader">26. Group</h2>
              <p>
                Means a group as defined in clause (b) of the Explanation to
                Section 5 of the Competition Act, 2002 (12 of 2003)
              </p>

              <br />
              <h2 className="definitionsHeader">
                27. Income Distribution Cum Capital Withdrawal
              </h2>
              <p>
                Income Distribution cum Capital Withdrawal (IDCW) means
                distribution of income/capital by a Scheme out of distributable
                surplus, if any, in accordance with the SEBI Regulations, Master
                Circular and the SID. IDCW may include return of capital, and
                declaration/distribution of IDCW is subject to availability of
                distributable surplus and approval of the Trustee/AMC, as
                applicable.
              </p>

              <br />
              <h2 className="definitionsHeader">28. IDCW (Payout) Option</h2>
              <p>
                Refers to the Income Distribution cum Capital Withdrawal Option
                (Payout) Option.
              </p>

              <br />
              <h2 className="definitionsHeader">
                29. IDCW (Reinvestment) Option
              </h2>
              <p>
                Refers to the Income Distribution cum Capital Withdrawal Option
                – Reinvestment Option.
              </p>

              <br />
              <h2 className="definitionsHeader">30. Income Distribution</h2>
              <p>
                Income Distribution shall be read as Income Distribution cum
                Capital Withdrawal (IDCW) wherever the context so requires.
              </p>

              <br />
              <h2 className="definitionsHeader">31. I.T. Act</h2>
              <p>Income-tax Act, 2025, as amended from time to time.</p>

              <br />
              <h2 className="definitionsHeader">
                32. Investment Management Agreement (“IMA”)
              </h2>
              <p>
                Investment Management Agreement dated 1st September, 1994
                between JM Financial Trustee Company Private Limited and JM
                Financial Asset Management Limited, as amended from time to
                time.
              </p>

              <br />
              <h2 className="definitionsHeader">33. ISIN</h2>
              <p>
                International Securities Identification Number, a unique code
                that identifies a specific security.
              </p>

              <br />
              <h2 className="definitionsHeader">
                34. “InvIT” or “Infrastructure Investment Trust”
              </h2>
              <p>
                shall have the meaning assigned to it under clause (za) of
                sub-regulation (1) of regulation 2 of the Securities and
                Exchange Board of India (Infrastructure Investment Trusts)
                Regulations, 2014, as amended from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">
                35. JM Financial Mutual Fund or JMF or the Fund
              </h2>
              <p>
                JM Financial Mutual Fund, a mutual fund constituted as a trust
                under the provisions of the Indian Trusts Act, 1882 and
                registered with SEBI bearing Registration No. MF/015/94/8 dated
                September 15, 1994.
              </p>

              <br />
              <h2 className="definitionsHeader">36. JM ISC</h2>
              <p>
                Investor Service Centre(s) of JM Financial Mutual Fund, the
                Registrar and Transfer Agent, and such other locations, digital
                platforms, exchange platforms, MF Utilities/MFCentral or other
                facilities as may be designated by the AMC from time to time as
                Official Points of Acceptance for receiving transactions during
                the NFO and ongoing period, as specified in the SID/SAI or on
                the AMC website. The cut-off timing for transactions shall be
                reckoned with reference to the time-stamp at the applicable
                Official Point of Acceptance, subject to SEBI Regulations and
                the Master Circular. The AMC may change the list of Official
                Points of Acceptance from time to time and publish the updated
                list on the Fund/AMC website.
              </p>

              <br />
              <h2 className="definitionsHeader">37. KIM</h2>
              <p>
                Key Information Memorandum of the Scheme(s) issued by JM
                Financial Mutual Fund.
              </p>

              <br />
              <h2 className="definitionsHeader">38. Load</h2>
              <p>
                Load means a charge that may be levied by a mutual fund as
                permitted under the SEBI Regulations. Entry load is not
                permitted; Exit Load, if any, may be levied at the time of
                redemption/repurchase/switch-out of Units in accordance with the
                SID and applicable SEBI requirements.
              </p>

              <br />
              <h2 className="definitionsHeader">
                39. Money market instruments
              </h2>
              <p>
                Money market instruments include commercial papers, commercial
                bills, treasury bills, Government Securities having an unexpired
                maturity of up to one year, call or notice money, certificates
                of deposit, usance bills and any other like instruments as
                specified or permitted by the Reserve Bank of India/SEBI from
                time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">40. Master Circular</h2>
              <p>
                SEBI Master Circular for Mutual Funds No.
                HO/24/13/11(1)2026-IMD-POD-1/I/7602/2026 dated March 20, 2026,
                effective April 1, 2026, as amended, modified, replaced or
                re-enacted from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">41. Market Abuse</h2>
              <p>
                Market Abuse includes manipulative, fraudulent and unfair trade
                practices which may contravene Section 12A of the SEBI Act or
                any provision of the Securities and Exchange Board of India
                (Prohibition of Fraudulent and Unfair Trade Practices relating
                to Securities Market) Regulations, 2003 or the Securities and
                Exchange Board of India (Prohibition of Insider Trading)
                Regulations, 2015, each as amended from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">42. Mutual Fund</h2>
              <p>
                Mutual Fund means a fund established in the form of a trust and
                registered under the SEBI Regulations, which raises monies
                through sale of Units to the public under one or more schemes
                for investing in securities, money market instruments, gold or
                gold related instruments, silver or silver related instruments
                and such other assets/instruments as may be specified or
                permitted by SEBI from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">
                43. Mutual Fund Distributor (“MFD”)
              </h2>
              <p>
                Such persons, firms, companies, corporates or other entities who
                fulfil the criteria laid down by SEBI/AMFI from time to time and
                are empanelled by the AMC to distribute/sell/market the schemes
                of the Fund.
              </p>

              <br />
              <h2 className="definitionsHeader">44. NAV</h2>
              <p>
                Net Asset Value of the Units of the Scheme, calculated in the
                manner provided in the SID/SAI and in conformity with the SEBI
                Regulations and the Master Circular, as amended from time to
                time.
              </p>

              <br />
              <h2 className="definitionsHeader">45. NRI</h2>
              <p>Non-Resident Indian.</p>

              <br />
              <h2 className="definitionsHeader">
                46. Official Point(s) of Acceptance / OPA
              </h2>
              <p>
                Official Point(s) of Acceptance / OPA means the JM ISC(s),
                offices of the Registrar and Transfer Agent, AMC website, MF
                Utilities/MFCentral, recognised stock exchange platforms and
                such other physical or electronic locations/platforms as may be
                designated by the AMC from time to time for receiving
                applications/transactions. The time-stamp at the applicable OPA
                shall be considered for determining the Applicable NAV, subject
                to the SEBI Regulations, Master Circular and the SID.
              </p>

              <br />
              <h2 className="definitionsHeader">47. Open-Ended Scheme</h2>
              <p>
                Open-Ended Scheme means a scheme of a mutual fund which offers
                units for sale without specifying any duration for redemption
              </p>

              <br />
              <h2 className="definitionsHeader">48. Portfolio</h2>
              <p>
                The portfolio of a Scheme of JM Financial Mutual Fund shall
                include all Permissible Investments, other assets and cash/cash
                equivalents held by or on behalf of the Scheme.
              </p>

              <br />
              <h2 className="definitionsHeader">49. Private Placement</h2>
              <p>
                Private Placement means any offer of Units of a mutual fund
                scheme or invitation to subscribe such Units to a select group
                of persons by a mutual fund (other than by way of public offer)
                through issue of a placement memorandum and which is not
                calculated to result, directly or indirectly, in the Units
                becoming available for subscription or purchase by persons other
                than those receiving the offer or invitation.
              </p>

              <br />
              <h2 className="definitionsHeader">50. Rating</h2>
              <p>
                means an opinion regarding securities, expressed in the form of
                standard symbols or in any other standardized manner, assigned
                by a Credit Rating Agency and used by the issuer of such
                securities to comply with any requirement of the Securities and
                Exchange Board of India (Credit Rating Agencies) Regulations,
                1999.
              </p>

              <br />
              <h2 className="definitionsHeader">
                51. REIT or Real Estate Investment Trust
              </h2>
              <p>
                REIT or Real Estate Investment Trust shall have the meaning
                assigned to it under clause (zm) of sub-regulation (1) of
                regulation 2 of the Securities and Exchange Board of India (Real
                Estate Investment Trusts) Regulations, 2014, as amended from
                time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">52. RBI</h2>
              <p>
                Reserve Bank of India established under the Reserve Bank of
                India Act, 1934, as amended from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">
                53. Registrar or Transfer Agent
              </h2>
              <p>
                M/s. KFin Technologies Limited (KFin), Mumbai, currently acting
                as Registrar and Transfer Agent to the Scheme(s) and/or any
                other Registrar and Transfer Agent appointed by the AMC from
                time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">54. Repo</h2>
              <p>
                means an instrument for borrowing funds by selling securities of
                the Central Government or a State Government or of such
                securities of a local authority as may be specified in this
                behalf by the Central Government or foreign securities, with an
                agreement to repurchase the said securities on a mutually agreed
                future date at an agreed price which includes interest for the
                funds borrowed
              </p>

              <br />
              <h2 className="definitionsHeader">55. Reverse Repo</h2>
              <p>
                means an instrument for lending funds by purchasing securities
                of the Central Government or a State Government or of such
                securities of a local authority as may be specified in this
                behalf by the Central Government or foreign securities, with an
                agreement to resell the said securities on a mutually agreed
                future date at an agreed price which includes interest for the
                funds lent;
              </p>

              <br />
              <h2 className="definitionsHeader">
                56. Repurchase /Redemption Price
              </h2>
              <p>
                Price at which the Units can be bought back/redeemed by the
                Fund, calculated based on the Applicable NAV after adjustment of
                Exit Load, transaction charges, taxes or other charges, if any,
                as permitted under the SID and applicable SEBI requirements.
              </p>

              <br />
              <h2 className="definitionsHeader">57. SAI</h2>
              <p>
                Statement of Additional Information issued by JM Financial
                Mutual Fund containing statutory, tax, legal, general and other
                information relating to the Fund and its Schemes, as amended
                from time to time, and forming part of the SID by reference.
              </p>

              <br />
              <h2 className="definitionsHeader">
                58. Sales / Subscription Price
              </h2>
              <p>
                Price at which Units can be purchased/subscribed, calculated
                based on the Applicable NAV and any charges, if applicable and
                permitted under the SID and applicable SEBI requirements.
              </p>

              <br />
              <h2 className="definitionsHeader">59. Scheme</h2>
              <p>
                A scheme of JM Financial Mutual Fund offered under the relevant
                Scheme Information Document.
              </p>

              <br />
              <h2 className="definitionsHeader">
                60. Scheme Information Document
              </h2>
              <p>
                Scheme Information Document means the document issued by JM
                Financial Mutual Fund setting forth information about a Scheme
                and offering Units of such Scheme, as amended/supplemented from
                time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">61. SEBI or the Board</h2>
              <p>
                The Securities and Exchange Board of India established under the
                Securities and Exchange Board of India Act, 1992.
              </p>

              <br />
              <h2 className="definitionsHeader">62. SEBI Act</h2>
              <p>
                Securities and Exchange Board of India Act, 1992 as amended from
                time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">
                63. SEBI Regulations or the Regulations
              </h2>
              <p>
                The Securities and Exchange Board of India (Mutual Funds)
                Regulations, 2026, as amended, modified, replaced or re-enacted
                from time to time, including circulars, master circulars,
                notifications, guidelines, clarifications, press releases or
                directions issued by SEBI or any other statutory/regulatory
                authority applicable to mutual funds.
              </p>

              <br />
              <h2 className="definitionsHeader">64. Securities</h2>
              <p>
                Include shares, scrips, stocks, bonds, debentures, debenture
                stock, or other marketable securities of a like nature in or of
                any incorporated company 15[or a pooled investment vehicle or
                other body corporate, derivative, units or any other instrument
                issued by any collective investment scheme to the investors in
                such schemes, security receipt as defined in clause (zg) of
                section 2 of the Securitisation and Reconstruction of Financial
                Assets and Enforcement of Security Interest Act,2002, units or
                any other such instrument issued to the investors under any
                mutual fund scheme, units or any other instrument issued by any
                pooled investment vehicle, any certificate or instrument (by
                whatever name called), issued to an investor by any issuer being
                a special purpose distinct entity which possesses any debt or
                receivable, including mortgage debt, assigned to such entity,
                and acknowledging beneficial interest of such investor in such
                debt or receivable, including mortgage debt, as the case may be;
                Government securities, such other instruments as may be declared
                by the Central Government to be securities; and rights or
                interest in securities.
              </p>

              <br />
              <h2 className="definitionsHeader">
                65. Silver Related Instrument
              </h2>
              <p>
                Silver related instrument shall mean an instrument as may be
                specified by SEBI, which has silver as the underlying product.
              </p>

              <br />
              <h2 className="definitionsHeader">66. Sponsor</h2>
              <p>
                JM Financial Limited (the Sponsor of JM Financial Mutual Fund),
                a company incorporated and registered under the Companies Act,
                1956 and includes its successors and assigns.
              </p>

              <br />
              <h2 className="definitionsHeader">67. Stock Exchange/Exchange</h2>
              <p>
                BSE Limited, National Stock Exchange of India Limited or any
                other recognised stock exchange in India, as may be approved by
                the Trustee and/or permitted by SEBI from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">68. Stock Lending</h2>
              <p>
                Lending of securities to another person or entity for a fixed
                period of time, at a negotiated compensation, in accordance with
                the SEBI Regulations, the Master Circular and applicable
                securities lending and borrowing framework.
              </p>

              <br />
              <h2 className="definitionsHeader">69. Switch</h2>
              <p>
                Switch means redemption of Units in one Scheme/Plan/Option and
                purchase of Units in another Scheme/Plan/Option of JM Financial
                Mutual Fund, subject to the terms of the relevant SID(s),
                applicable cut-off timings, loads, taxes and regulatory
                requirements.
              </p>

              <br />
              <h2 className="definitionsHeader">70. Total Expense Ratio</h2>
              <p>
                Total Expense Ratio (TER) means the ratio of the total expenses
                charged to a Scheme to the net assets/AUM of the Scheme,
                calculated, charged and disclosed in the manner specified under
                the SEBI Regulations and the Master Circular from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">71. Tri-party Repo</h2>
              <p>
                Tri-party repo is a type of repo contract where a third entity
                (apart from the borrower and lender), called a Tri-Party Agent,
                acts as an intermediary between the two parties to the repo to
                facilitate services like collateral selection, payment and
                settlement, custody and management during the life of the
                transaction.
              </p>

              <br />
              <h2 className="definitionsHeader">72. Trustee</h2>
              <p>
                Trustee means JM Financial Trustee Company Private Limited, the
                trustee company that holds the trust property of JM Financial
                Mutual Fund in trust for the benefit of Unit holders, and
                includes its successors and assigns.
              </p>

              <br />
              <h2 className="definitionsHeader">73. Trust Deed</h2>
              <p>
                The registered Trust Deed dated 1st September, 1994 establishing
                the JM Financial Mutual Fund as amended from time to time.
              </p>

              <br />
              <h2 className="definitionsHeader">74. Trust Property</h2>
              <p>
                Includes Permissible Investments, other assets and cash/cash
                equivalents of the Fund/Scheme, or any part thereof, which may
                be converted, varied or substituted from time to time in
                accordance with applicable law.
              </p>

              <br />
              <h2 className="definitionsHeader">75. Units under the Scheme</h2>
              <p>
                The interest of the Unit holders in the Scheme, with each Unit
                representing one undivided beneficial interest in the assets of
                the Scheme.
              </p>

              <br />
              <h2 className="definitionsHeader">
                76. Unit holder / Unitholder
              </h2>
              <p>Unit holder/Unitholder means a person holding Units in a Scheme of the Fund.</p>

              <br />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default DefinationndInterpretation;
